$(document).ready(function(){
  // Revaree Popup
  if (!localStorage.getItem("revareePopupDismissed")) {
    if ($('.revaree-popup-popup').length > 0) {
      $('.revaree-popup-popup').removeClass('disable-popup');
      $('body').addClass('overflow-hidden');
    }
  }
  $(document).on('click', '.revaree-popup-popup-close, .revaree-popup-no-thanks-text, .revaree-popup-popup', function(e){
    if ($(e.target).hasClass('revaree-popup-popup') || $(e.target).hasClass('revaree-popup-popup-close') || $(e.target).hasClass('revaree-popup-no-thanks-text')) {
      $('.revaree-popup-popup').addClass('disable-popup');
      $('body').removeClass('overflow-hidden');
      localStorage.setItem('revareePopupDismissed', 'true');
    }
  });

  $(document).on('click', '.revaree-popup-popup-copy-code-cta', function() {
    let textToCopy = $('.revaree-popup-popup-offer-text span').text();
    navigator.clipboard.writeText(textToCopy).then(function() {
      $('.revaree-popup-copied-text').css('display', 'block');
      $('.revaree-popup-text').css('display', 'none');
    }).catch(function(error) {
      console.error('Error copying text: ', error);
    });
  });

  //Shop By symptom (One Question Quiz)
  $(document).on('click', '.one-question-quiz-website-redesign-button button', function(){
    let trackName = $(this).attr('data-track-name');
    $(this).addClass('one-question-quiz-website-redesign-active').siblings().removeClass('one-question-quiz-website-redesign-active');
    $('.js-product-box').removeClass('one-question-quiz-website-redesign-show-section');
    $('.js-product-box[data-track-name="'+trackName+'"]').addClass('one-question-quiz-website-redesign-show-section');
  });
});


